const swiperScript = document.createElement('script');

// swiperScript.src = 'https://unpkg.com/swiper@7/swiper-bundle.min.js';
swiperScript.defer = true;
swiperScript.async = true;

swiperScript.onload = function() {
  if (window.location.pathname === '/') {
    new Swiper('.hero-swiper', {
      autoplay: {
        delay: 5000,
      },
      pagination: {
        bulletActiveClass: 'pagination-bars-active',
        bulletClass: 'pagination-bars',
        clickable: true,
        el: '.hero-swiper__pagination',
        renderBullet: function (index, className) {
          return `<button class="${className} bg-gray-400 h-1 mx-1 rounded-md w-4" type="button"></button>`
        },
      },
    });

    new Swiper('.promise-swiper', {
      pagination: {
        bulletActiveClass: 'pagination-bars-active',
        bulletClass: 'pagination-bars',
        clickable: true,
        el: '.promise-swiper__pagination',
        renderBullet: function (index, className) {
          return `<button class="${className} bg-gray-400 h-1 mx-1 rounded-md w-4" type="button"></button>`
        },
      },
    });
  }

  if (window.location.pathname.indexOf('/collections') > -1) {
    new Swiper('.render-swiper', {
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
    });
  }

  if (document.querySelector('.swiper-section')) {
    new Swiper('.swiper-section', {
      autoplay: {
        delay: 5000,
      },
      pagination: {
        bulletActiveClass: 'pagination-bars-active',
        bulletClass: 'pagination-bars',
        clickable: true,
        el: '.swiper-section__pagination',
        renderBullet: function (index, className) {
          return `<button class="${className} bg-gray-400 h-1 mx-1 rounded-md w-4" type="button"></button>`
        },
      },
    });
  }
}

document.getElementsByTagName('head')[0].appendChild(swiperScript);

// BEGIN: We passed the cart we got from the update to make the render faster

async function renderCart(customCart) {
// console.log("Original Code")
  let cart = customCart;

  if(!cart?.items) {
    cart = await fetch('/cart.js')
    .then((response) => response.json())
    .then((data) => data);
  }

// END: We passed the cart we got from the update to make the render faster

  const templateText = document.getElementById('cart-template').textContent;
  const template = Handlebars.compile(templateText);
  const items = [];

  const { format } = new Intl.NumberFormat('en-US', { style: 'currency', currency: cart.currency });

  for (let i = 0; i < cart.items.length; i += 1) {
    const imageUrlSplit = cart.items[i].featured_image.url.split('.');
    imageUrlSplit[imageUrlSplit.length - 2] += '_150x';
    const imageUrl = imageUrlSplit.join('.');
	var selling_plan = false;
    
    const originalPrice = format(cart.items[i].original_line_price / 100);
    const price = format(cart.items[i].line_price / 100);
    
    items.push({
      hideQuantitySelector:
        cart.items[i].properties?.bundle_type === 'CHILD' ||
        cart.items[i].properties?.stack_name ||
        cart.items[i].properties?.stack_product,
      id: cart.items[i].key,
      variant_id: cart.items[i].id,
      image: imageUrl,
      isBundle: cart.items[i].properties?.bundle_type === 'CHILD',
      quantity: cart.items[i].quantity,
      originalPrice: originalPrice,
      price: price,
      isDiscounted: price !== originalPrice,
      productTitle: cart.items[i].product_title.replace('|', '-'),
      stackId: cart.items[i].properties?.stack_id,
      stackProduct: cart.items[i].properties?.stack_product,
      sellingPlan: cart.items[i].selling_plan_allocation?.selling_plan.name,
      stackName: cart.items[i].properties?.stack_name,
      variantTitle: cart.items[i].variant_title?.replace('/ 1 Tub', ''),
      url: cart.items[i].url,
      item_json: JSON.stringify(cart.items[i]),
      loop_index: i,
      _subscription_only: cart.items[i].properties?._subscription_only,
    });
    
    if(cart.items[i]?.properties?.stack_product){
      var selling_plan = true;
    }
   
   
  }
    

  // ============================================
  // CART THRESHOLD CONFIGURATION
  // ============================================
  const THRESHOLDS = {
    freeShipping: 9900,  // $99 in cents
    freeBundle: 14900    // $149 in cents
  };

  // Check for subscription items
  let hasSellingPlan = false;
  for (let i = 0; i < cart.items.length; i += 1) {
    if (cart.items[i].selling_plan_allocation?.selling_plan.name) {
      hasSellingPlan = true;
      break;
    }
  }

  // Subscription items get free shipping automatically
  const effectiveFreeShippingThreshold = hasSellingPlan ? 0 : THRESHOLDS.freeShipping;

  // ============================================
  // CALCULATE CART STATUS
  // ============================================
  const cartTotal = cart.total_price;
  const hasUnlockedShipping = cartTotal >= effectiveFreeShippingThreshold;
  const hasUnlockedBundle = cartTotal >= THRESHOLDS.freeBundle;

  // ============================================
  // CALCULATE PROGRESS PERCENTAGE (UPDATED)
  // ============================================
  let progressPercent;
  const freeShippingThreshold = THRESHOLDS.freeShipping;
  const freeBundleThreshold = THRESHOLDS.freeBundle;
  if (hasSellingPlan) 
  {
    if (cartTotal >= freeBundleThreshold) 
    {
      progressPercent = 100;
    } 
    else if (cartTotal <= freeShippingThreshold) {
      // Scale 0% → 50% until free shipping
      progressPercent = 50;
    } 
    else {
      // Scale 50% → 88% between shipping and bundle
      const rangeProgress = (cartTotal - freeShippingThreshold) / (freeBundleThreshold - freeShippingThreshold);
      progressPercent = 50 + rangeProgress * (88 - 50);
    }
  }  
  else 
  {
    // Normal case: no selling plan
    if (cartTotal >= THRESHOLDS.freeBundle) 
    {
      progressPercent = 100;
    }
    else if (cartTotal <= THRESHOLDS.freeShipping) {
      progressPercent = (cartTotal / THRESHOLDS.freeShipping) * 50;
    }
    else 
    {
      // Between freeShipping (50%) and freeBundle (88%)
      const rangeStart = THRESHOLDS.freeShipping;
      const rangeEnd = THRESHOLDS.freeBundle;
      const bundleProgress = (cartTotal / THRESHOLDS.freeBundle);
      const rangeProgress = (cartTotal - rangeStart) / (rangeEnd - rangeStart);
      progressPercent = 50 + rangeProgress * (88 - 50); // 50% → 88%
      
    }
  }


// ============================================
// DETERMINE MESSAGES
// ============================================
let progressMessage;
let stickyBannerMessage = '';
let stickyBannerSubtext = 'Includes: TL Backpack, TL Water Bottle, 5 Free Samples';

  if (hasSellingPlan) 
  {
    if (cartTotal < THRESHOLDS.freeBundle) 
      {
        let amountNeeded = THRESHOLDS.freeBundle - cartTotal;
        // progressMessage = `Add ${format(amountNeeded / 100)} for a Free Bundle!`;
        // stickyBannerMessage = `Add ${format(amountNeeded / 100)} More For Your Free Bundle!`;
        // Prevent negative values and round to nearest dollar
        amountNeeded = Math.max(0, Math.round(amountNeeded / 100) * 100);
        // Format the rounded amount as currency
        const formattedAmount = `$${Math.round(amountNeeded / 100)}`;
        progressMessage = `Add ${formattedAmount} for a Free Bundle!`;
        stickyBannerMessage = `Add ${formattedAmount} More For Your Free Bundle!`;
      } 
      else 
      {
        progressMessage = "You've Unlocked Free Shipping + Free Bundle!";
        stickyBannerMessage = "You've Unlocked Your Free Bundle!";
      }
  } 
  else 
  {
    if (cartTotal < effectiveFreeShippingThreshold) 
    {
      let amountNeeded = effectiveFreeShippingThreshold - cartTotal;
      amountNeeded = Math.max(0, Math.round(amountNeeded / 100) * 100);
      let formattedAmount = `$${Math.round(amountNeeded / 100)}`;
      progressMessage = `Add ${formattedAmount} for Free Shipping!`;

      amountNeeded = THRESHOLDS.freeBundle - cartTotal;
      amountNeeded = Math.max(0, Math.round(amountNeeded / 100) * 100);
      formattedAmount = `$${Math.round(amountNeeded / 100)}`;
      stickyBannerMessage = `Add ${formattedAmount} More For Your Free Bundle!`;

    } 
    else if (cartTotal < THRESHOLDS.freeBundle) 
    {
      let amountNeeded = THRESHOLDS.freeBundle - cartTotal;
      amountNeeded = Math.max(0, Math.round(amountNeeded / 100) * 100);
      const formattedAmount = `$${Math.round(amountNeeded / 100)}`;
      progressMessage = `Add ${formattedAmount} for a Free Bundle!`;
      stickyBannerMessage = `Add ${formattedAmount} More For Your Free Bundle!`;
    } 
    else 
    {
      progressMessage = "You've Unlocked Free Shipping + Free Bundle!";
      stickyBannerMessage = "You've Unlocked Your Free Bundle!";
    }
  }

  // ============================================
  // PREPARE TEMPLATE DATA
  // ============================================
  const subtotal = format(cart.original_total_price / 100);
  const subtotal_discounts = format(cart.total_price / 100);

  // ============================================
  // RENDER CART MENU CONTAINER
  // ============================================
  document.getElementById('cart-menu-container').innerHTML = template({
    empty: cart.items.length === 0,
    items,
    savings: format(cart.total_discount / 100),
    subtotal: subtotal,
    subtotal_discounts,
    showBothSubtotals: subtotal !== subtotal_discounts,
    subscription_product: hasSellingPlan,
    total_cart_count: `${cart.item_count} ${cart.item_count > 1 ? 'items' : 'item'}`,
    
    // Progress bar data
    progress_percent: Math.min(100, Math.max(0, progressPercent)),
    progress_message: progressMessage,
    has_unlocked_shipping: hasUnlockedShipping,
    has_unlocked_bundle: hasUnlockedBundle,
    
    // Bundle widget data
    bundle_locked: !hasUnlockedBundle,
    amount_to_bundle: hasUnlockedBundle ? 0 : format((THRESHOLDS.freeBundle - cartTotal) / 100),
    
    // Thresholds
    shipping_threshold: format(effectiveFreeShippingThreshold / 100),
    bundle_threshold: Math.round(THRESHOLDS.freeBundle / 100)
  });

  // ============================================
  // RENDER STICKY FOOTER BANNER (UPDATED DESIGN)
  // ============================================
  function renderStickyBanner() {
    const stickyBannerContainer = document.getElementById('sticky-footer-banner');
    const stickyBannerWrapper = document.getElementById('sticky-footer-banner-wrapper');
    const cartMenu = document.getElementById('cart-menu');
    
    if (!stickyBannerContainer) return;

    // 🔒 Skip rendering if cart drawer is visible (no 'hidden' class)
    // if (cartMenu && !cartMenu.classList.contains('hidden')) {
    //   console.log('Cart menu is visible — sticky banner hidden.');
    //   stickyBannerWrapper.style.transform = 'translateY(100%)';
    //   stickyBannerWrapper.style.position = 'unset';
    // }
    
    const isDismissed = sessionStorage.getItem("stickyBannerDismissed") === "true";
    const showBanner = cart.item_count >= 0 && !isDismissed;

    console.log(" cart.item_count",  cart.item_count);
    console.log("isDismissed",  isDismissed);
    
    if (!showBanner) {
      stickyBannerContainer.innerHTML = '';
      return;
    }
    

    // Build progress bar color class
    const progressColorClass = hasUnlockedShipping ? 'sticky-progress-green' : 'sticky-progress-orange';

    // Build status icon HTML - DOLLAR SIGN when locked, CHECKMARK when unlocked
    const statusIconHTML = hasUnlockedBundle 
      ? `<div class="sticky-icon">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM16.6402 8.2318C17.0645 8.58537 17.1218 9.21593 16.7682 9.64021L11.7682 15.6402C11.5937 15.8497 11.3411 15.9788 11.0691 15.9976C10.797 16.0165 10.5291 15.9234 10.3273 15.74L7.32733 13.0127C6.91868 12.6412 6.88856 12.0087 7.26007 11.6001C7.63157 11.1914 8.26402 11.1613 8.67268 11.5328L10.9002 13.5578L15.2318 8.35984C15.5854 7.93556 16.2159 7.87824 16.6402 8.2318Z" fill="#039846"/>
          </svg>
          
        </div>`
      : `<div class="sticky-icon">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.4" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#818082"/>
            <path d="M15.7491 10.73V10C15.7491 9.07 15.7491 6.25 11.9991 6.25C8.24915 6.25 8.24915 9.07 8.24915 10V10.73C7.02915 11 6.61914 11.79 6.61914 13.5V14.5C6.61914 16.7 7.29915 17.38 9.49915 17.38H14.4991C16.6991 17.38 17.3792 16.7 17.3792 14.5V13.5C17.3792 11.79 16.9691 11 15.7491 10.73ZM11.9991 15.1C11.3891 15.1 10.8992 14.61 10.8992 14C10.8992 13.39 11.3891 12.9 11.9991 12.9C12.6091 12.9 13.0991 13.39 13.0991 14C13.0991 14.61 12.6091 15.1 11.9991 15.1ZM14.2491 10.62H9.74915V10C9.74915 8.54 10.1091 7.75 11.9991 7.75C13.8891 7.75 14.2491 8.54 14.2491 10V10.62Z" fill="#ffffff"/>
          </svg>
        </div>`;

    const bundleIcons = hasUnlockedBundle 
      ? `<div class="bundle-icons bundle-icons-green"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
            <path d="M19.5 7.75H18.1C18.5 7.27 18.75 6.67 18.75 6C18.75 4.48 17.52 3.25 16 3.25C14.32 3.25 12.84 4.14 12 5.46C11.16 4.14 9.68 3.25 8 3.25C6.48 3.25 5.25 4.48 5.25 6C5.25 6.67 5.5 7.27 5.9 7.75H4.5C3.81 7.75 3.25 8.31 3.25 9V11.5C3.25 12.1 3.68 12.58 4.25 12.7V19.5C4.25 20.19 4.81 20.75 5.5 20.75H18.5C19.19 20.75 19.75 20.19 19.75 19.5V12.7C20.32 12.58 20.75 12.1 20.75 11.5V9C20.75 8.31 20.19 7.75 19.5 7.75ZM19.25 11.25H12.75V9.25H19.25V11.25ZM16 4.75C16.69 4.75 17.25 5.31 17.25 6C17.25 6.69 16.69 7.25 16 7.25H12.84C13.18 5.82 14.47 4.75 16 4.75ZM8 4.75C9.53 4.75 10.82 5.82 11.16 7.25H8C7.31 7.25 6.75 6.69 6.75 6C6.75 5.31 7.31 4.75 8 4.75ZM4.75 9.25H11.25V11.25H4.75V9.25ZM5.75 12.75H11.25V19.25H5.75V12.75ZM18.25 19.25H12.75V12.75H18.25V19.25Z" fill="#fff"/>
          </svg></div>`
          :
          `<div class="bundle-icons "><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
            <path d="M19.5 7.75H18.1C18.5 7.27 18.75 6.67 18.75 6C18.75 4.48 17.52 3.25 16 3.25C14.32 3.25 12.84 4.14 12 5.46C11.16 4.14 9.68 3.25 8 3.25C6.48 3.25 5.25 4.48 5.25 6C5.25 6.67 5.5 7.27 5.9 7.75H4.5C3.81 7.75 3.25 8.31 3.25 9V11.5C3.25 12.1 3.68 12.58 4.25 12.7V19.5C4.25 20.19 4.81 20.75 5.5 20.75H18.5C19.19 20.75 19.75 20.19 19.75 19.5V12.7C20.32 12.58 20.75 12.1 20.75 11.5V9C20.75 8.31 20.19 7.75 19.5 7.75ZM19.25 11.25H12.75V9.25H19.25V11.25ZM16 4.75C16.69 4.75 17.25 5.31 17.25 6C17.25 6.69 16.69 7.25 16 7.25H12.84C13.18 5.82 14.47 4.75 16 4.75ZM8 4.75C9.53 4.75 10.82 5.82 11.16 7.25H8C7.31 7.25 6.75 6.69 6.75 6C6.75 5.31 7.31 4.75 8 4.75ZM4.75 9.25H11.25V11.25H4.75V9.25ZM5.75 12.75H11.25V19.25H5.75V12.75ZM18.25 19.25H12.75V12.75H18.25V19.25Z" fill="#fff"/>
          </svg></div>`;
    
    // Product image faded class
    const imageClass = hasUnlockedBundle ? 'sticky-bundle-img' : 'sticky-bundle-img sticky-bundle-img-faded';
    
    // Bundle image URL (replace with your actual image path)
    const bundleImageUrl = 'https://cdn.shopify.com/s/files/1/0866/7664/files/628574dc290af32f961edd50103312297f124754.png?v=1762789668'; // Update this path
    
    // Build the complete banner HTML
    const bannerHTML = `
      <!-- Mini Progress Bar -->
      <div class="sticky-progress-track">
        <div id="sticky-progress-fill" 
            class="sticky-progress-fill ${progressColorClass}"
            style="width: ${progressPercent}%;">
        </div>
      </div>
      
      <!-- Banner Content -->
      <div class="sticky-banner-content">
        ${bundleIcons}
        <!-- Status Icon -->
        <div class="sticky-icon-wrapper">
          ${statusIconHTML}
        </div>
        
        <!-- Bundle Image -->
        <div class="sticky-product-image">
          <img src="${bundleImageUrl}" 
              alt="Bundle"
              class="${imageClass}">
        </div>
        
        <!-- Text Content -->
        <div class="sticky-text-content">
          <div class="sticky-main-text ${hasUnlockedBundle ? 'sticky-text-success' : ''}">
            ${stickyBannerMessage}
          </div>
          <div class="sticky-sub-text">
            ${stickyBannerSubtext}
          </div>
        </div>
        
      </div>
    `;
    


      console.log("progressColorClass:", progressColorClass);
    
    // Insert HTML into container
    stickyBannerContainer.innerHTML = bannerHTML;
  }

  // Call the render function
  renderStickyBanner();

  // ============================================
  // ANIMATE CART PROGRESS BAR
  // ============================================
  const progressBarContainer = document.getElementById("cart-progress-bar");
  if (progressBarContainer) {
    const progressFill = document.getElementById("progress-fill");
    
    if (progressFill) {
      const lastProgress = parseFloat(sessionStorage.getItem("cartLastProgress")) || 0;
      
      // Update color class based on shipping unlock status
      if (hasUnlockedShipping) {
        progressFill.classList.remove('progress-bar-orange');
        progressFill.classList.add('progress-bar-green');
      } else {
        progressFill.classList.remove('progress-bar-green');
        progressFill.classList.add('progress-bar-orange');
      }
      
      // Set initial state
      progressFill.style.transition = "none";
      progressFill.style.width = `${lastProgress}%`;
      
      // Trigger animation
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          progressFill.style.transition = "width 0.8s cubic-bezier(0.4, 0, 0.2, 1), background 0.5s ease";
          progressFill.style.width = `${progressPercent}%`;
        });
      });
      
      sessionStorage.setItem("cartLastProgress", progressPercent);
    }
  }

  // ============================================
  // ANIMATE STICKY BANNER PROGRESS BAR
  // ============================================
  const stickyBannerWrapper = document.getElementById("sticky-footer-banner-wrapper");
  if (stickyBannerWrapper) {
    const stickyProgressFill = document.getElementById("sticky-progress-fill");
    const isDismissed = sessionStorage.getItem("stickyBannerDismissed") === "true";
    
    if (stickyProgressFill) {
      const lastStickyProgress = parseFloat(sessionStorage.getItem("stickyLastProgress")) || 0;
      
      // Update color class - Orange when locked, Green when unlocked
      if (hasUnlockedBundle) {
        stickyProgressFill.classList.remove('sticky-progress-orange');
        stickyProgressFill.classList.add('sticky-progress-green');
      } else {
        stickyProgressFill.classList.remove('sticky-progress-green');
        stickyProgressFill.classList.add('sticky-progress-orange');
      }
      
      // Animate
      stickyProgressFill.style.transition = "none";
      stickyProgressFill.style.width = `${lastStickyProgress}%`;
      
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          stickyProgressFill.style.transition = "width 0.8s cubic-bezier(0.4, 0, 0.2, 1), background 0.5s ease";
          stickyProgressFill.style.width = `${progressPercent}%`;
        });
      });
      
      sessionStorage.setItem("stickyLastProgress", progressPercent);
    }
    
    // Show/hide banner with animation
    if (cart.item_count >= 0 && !isDismissed) {
      stickyBannerWrapper.classList.add('sticky-banner-visible');
      document.body.classList.add('sticky-banner-active');
    } else {
      stickyBannerWrapper.classList.remove('sticky-banner-visible');
      document.body.classList.remove('sticky-banner-active');
    }
  }


  
  document.querySelectorAll('.cart-menu-swiper .swiper-slide[data-id]').forEach((elem) => {
    const productId = parseInt(elem.dataset.id, 10);
    const itemsInCart = cart.items.map((elem) => elem.product_id);

    if (itemsInCart.indexOf(productId) > -1) {
      elem.remove();
    }
  });

  new Swiper('.cart-menu-swiper', {
    autoplay: {
      delay: 5000,
    },
    pagination: {
      bulletActiveClass: 'pagination-bars-active pagination-bars-active--blue',
      bulletClass: 'pagination-bars',
      clickable: true,
      el: '.cart-menu-swiper__pagination',
      renderBullet: function (index, className) {
        return `<button class="${className} bg-gray-400 h-1 mx-1 rounded-md w-4" type="button"></button>`
      },
    },
  });

  

  document.getElementById('cart-menu-container').querySelectorAll('input').forEach((elem) => {
    elem.addEventListener('change', updateQuantity);
  });

  document.getElementById('cart-menu-container').querySelectorAll('button[data-stack-id]').forEach((elem) => {
    elem.addEventListener('click', function() {
      const { stackId } = elem.dataset;
      const updates = [];

      document.querySelectorAll('#cart-menu-container div[data-line-quantity]').forEach((item) => {
        if (item.querySelector('button[data-stack-id]')?.dataset.stackId === stackId) {
          updates.push(0);
        } else {
          updates.push(parseInt(item.dataset.lineQuantity, 10));
        }
      });

      fetch('/cart/update', {
        body: JSON.stringify({
          updates,
        }),
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        method: 'POST',
      }).then((response) => response.json())
        .then((response) => {
          renderCart();
        })
        .catch((e) => {
          console.error(e);
        });
    });
  });

  window.fetchAndProcessCartData();
  
}

window.addEventListener('load', async () => {
  await renderCart();
});


function updateQuantity() {
  const id = this.dataset.itemId;
  const quantity = this.valueAsNumber;

  // TODO: add some type of overlay opacity to prevent multiple interactions

  fetch('/cart/change', {
    body: JSON.stringify({
      id,
      quantity,
    }),
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    method: 'POST',
  }).then((response) => response.json())
    .then((response) => {
      if (response.status) {
        return;
      }
    //console.log(response.item_count);
      if(response.item_count < 1)
      {
          $('#cart-count').html("");
      }
      else
      {
        $('#cart-count').html("<number class='number cart-count'>"+response.item_count+"</number>");
      }
      renderCart(response);
    })
    .catch((e) => {
      console.error(e);
    });
}

function closeCartMenu() {
  document.getElementById('cart-menu-container').classList.replace('translate-x-0', 'translate-x-96');
  document.getElementById('cart-menu').classList.replace('opacity-1', 'opacity-0');

  setTimeout(() => {
    document.getElementById('cart-menu').classList.add('hidden');
  	// document.getElementById('gorgias-chat-container').classList.remove('hidden');
    document.body.classList.remove('overflow-hidden');
  }, 300);

  document.getElementById('cart-menu-container').querySelectorAll('input').forEach((elem) => {
    elem.removeEventListener('change', updateQuantity);
  });
}

function openCartMenu(customCart) {
  document.getElementById('cart-menu').classList.remove('hidden');
  document.body.classList.add('overflow-hidden');
  // document.getElementById('gorgias-chat-container').classList.add('hidden');

  renderCart(customCart);

  setTimeout(() => {
    document.getElementById('cart-menu').classList.replace('opacity-0', 'opacity-1');
    document.getElementById('cart-menu-container').classList.replace('translate-x-96', 'translate-x-0');
  }, 300);
}

document.querySelectorAll('.cart-menu-open').forEach((elem) => {
  elem.addEventListener('click', openCartMenu);
});

window.addEventListener('click', function(event) {
  if (event.target.closest('#cart-menu-container') === null
  && event.target.closest('#cart-menu-open') === null
  && event.target.closest('button') === null
  && event.target.closest('#subUpgradeModal') === null) {
    closeCartMenu();
  }

  if (event.target.closest('#cart-menu-close')) {
    closeCartMenu();
    // const stickyBannerWrapper = document.getElementById('sticky-footer-banner-wrapper');
    // const cartMenu = document.getElementById('cart-menu');
    // const stickyBannerContainer = document.getElementById('sticky-footer-banner');
    // if (!stickyBannerContainer) return;
    // // 🔒 Skip rendering if cart drawer is visible (no 'hidden' class)
    // if (cartMenu && !cartMenu.classList.contains('hidden')) {
    //   console.log('Cart menu is visible — sticky banner hidden.');
    //   stickyBannerWrapper.style.transform = 'translateY(0%)';
    //   stickyBannerWrapper.style.position = 'fixed';
    //   return;
    // }
  }
});

document.querySelectorAll('.has-dropdown').forEach((elem) => {
  const dropdown = elem.querySelector('.dropdown');

  if (dropdown) {
    elem.addEventListener('mouseenter', function() {
      dropdown.classList.replace('hidden', 'block');

      setTimeout(() => {
        dropdown.classList.replace('opacity-0', 'opacity-100');
      }, 50);
    });

    elem.addEventListener('mouseleave', function() {
      dropdown.classList.replace('opacity-100', 'opacity-0');

      setTimeout(() => {
        dropdown.classList.replace('block', 'hidden');
      }, 50);
    });
  }
});

document.getElementById('search-nav-open').addEventListener('click', function() {
  document.getElementById('search-nav').classList.remove('hidden');
     document.querySelectorAll('.focusme')[0].focus();
  document.querySelectorAll('.focusme')[1].focus();
});

// document.getElementById('search-nav-open-2').addEventListener('click', function() {
//   document.getElementById('search-nav-2').classList.remove('hidden');
//      document.querySelectorAll('.focusme')[0].focus();
//   document.querySelectorAll('.focusme')[1].focus();

// });

document.getElementById('search-nav-open-3').addEventListener('click', function() {
  document.getElementById('search-nav-3').classList.remove('hidden');
   document.querySelectorAll('.focusme')[0].focus();
  document.querySelectorAll('.focusme')[1].focus();
});

document.getElementById('search-nav-close').addEventListener('click', function() {
  document.getElementById('search-nav').classList.add('hidden');
});

// document.getElementById('search-nav-close-2').addEventListener('click', function() {
  
//   document.getElementById('search-nav-2').classList.add('hidden');
//   document.querySelector('body').classList.toggle("predictive-overflow-hidden", false)
// });

document.getElementById('search-nav-close-3').addEventListener('click', function() {
  document.getElementById('search-nav-3').classList.add('hidden');
});

document.getElementById('mobile-search-nav-open').addEventListener('click', function() {
  document.getElementById('mobile-search-nav').classList.remove('hidden');
});

document.getElementById('mobile-search-nav-close').addEventListener('click', function() {
  document.getElementById('mobile-search-nav').classList.add('hidden');
});

document.getElementById('mobile-nav-open').addEventListener('click', function() {
  document.getElementById('mobile-nav').classList.replace('hidden', 'flex');

  setTimeout(() => document.getElementById('mobile-nav').style.transform = 'translateY(0)', 100);
});

document.getElementById('mobile-nav-close').addEventListener('click', function() {
  document.getElementById('mobile-nav').style.transform = 'translateY(-100vh)';

  setTimeout(() => document.getElementById('mobile-nav').classList.replace('flex', 'hidden'), 100);
});



// Header Search Bar: START
const searchToggleButton = document.getElementById('search-nav-open-2');
const searchCloseButton = document.getElementById('search-nav-close-2');
const searchNav = document.getElementById('search-nav-2');
const searchInput = searchNav.querySelector('input[type="search"]');


// Function to check if search is open
function isSearchOpen() {
  return !searchNav.classList.contains('hidden');
}

function openSearch() {
  // Close mobile menu drawer if open
  if (window.menu && window.menu.classList.contains('active')) {
    window.toggleMenu();
  }

  searchNav.classList.remove('hidden');
  document.querySelectorAll('.focusme')[0]?.focus();
  document.querySelectorAll('.focusme')[1]?.focus();
  if (searchInput && searchInput.value.trim() !== "") {
    document.body.classList.add("predictive-overflow-hidden");
  } 
}

function closeSearch() {
  searchNav.classList.add('hidden');
  document.body.classList.toggle("predictive-overflow-hidden", false);
}

// Prevent scroll-close from interfering with a recent click
let justClicked = false;

// Toggle on search icon click
searchToggleButton.addEventListener('click', function () {
  justClicked = true;
  setTimeout(() => justClicked = false, 100); // Reset after short delay

  if (isSearchOpen()) {
    closeSearch();
  } else {
    openSearch();
  }
});

// Close on close button click
searchCloseButton.addEventListener('click', closeSearch);

// Close on scroll (but skip if click just happened)
window.addEventListener('scroll', function () {
  if (isSearchOpen() && !justClicked) {
    closeSearch();
  }
});

// Close on outside click
document.addEventListener('click', function (e) {
  const isClickInside =
    searchNav.contains(e.target) ||
    searchToggleButton.contains(e.target) ||
    searchCloseButton.contains(e.target);

  if (isSearchOpen() && !isClickInside) {
    closeSearch();
  }
});
// Header Search Bar: END


// Custom Search

function getProduct(path, id) {
  const promise = new Promise((resolve, reject) => {
    let url = path;

    if (url.indexOf('?') > -1) {
      url = url.split('?')[0];
    }

    fetch(`${url}?view=search`)
      .then((response) => response.text())
      .then((data) => {
        if (document.getElementById(id)) {
          if (!data.startsWith('<!doctype html>')) {
            document.getElementById(id).innerHTML = data;
          } else {
            document.getElementById(id).remove();
          }
        }

        resolve();
      })
      .catch((err) => reject(err));
  });

  return promise;
}

function updateSortList() {
  document.querySelectorAll('.snize-main-panel-dropdown-content').forEach(function (elem) {
    elem.querySelector('.snize-main-panel-dropdown-created-desc')?.parentElement.remove();
    elem.querySelector('.snize-main-panel-dropdown-created-asc')?.parentElement.remove();
    elem.querySelector('.snize-main-panel-dropdown-total_reviews-asc')?.parentElement.remove();
    elem.querySelector('.snize-main-panel-dropdown-total_reviews-desc')?.parentElement.remove();
    elem.querySelector('.snize-main-panel-dropdown-price-asc')?.parentElement.remove();
    elem.querySelector('.snize-main-panel-dropdown-price-desc')?.parentElement.remove();

    elem.appendChild(elem.querySelector('.snize-main-panel-dropdown-sales_amount-desc').parentElement);
    elem.appendChild(elem.querySelector('.snize-main-panel-dropdown-discount-desc').parentElement);
    elem.appendChild(elem.querySelector('.snize-main-panel-dropdown-reviews_average_score-asc').parentElement);
    elem.appendChild(elem.querySelector('.snize-main-panel-dropdown-reviews_average_score-desc').parentElement);
    elem.appendChild(elem.querySelector('.snize-main-panel-dropdown-title-asc').parentElement);
    elem.appendChild(elem.querySelector('.snize-main-panel-dropdown-title-desc').parentElement);
  });
}

async function updateSearchResults() {
  const loading = document.querySelectorAll('.snize-search-results-content .snize-skeleton-card').length > 0;

  if (loading) {
    setTimeout(() => updateSearchResults(), 200);
  } else {
    updateSortList();

    document.getElementById('snize-search-results-grid-mode').style.opacity = 0;

    const promises = [];

    document.querySelectorAll('.snize-search-results-content .snize-product').forEach((elem) => {
      const link = elem.querySelector('.snize-view-link');

      if (link) {
        const url = link.getAttribute('href');

        elem.innerHTML = '';

        promises.push(getProduct(url, elem.id));
      }
    });

    await Promise.all(promises);

    document.getElementById('snize-search-results-grid-mode').style.opacity = 1;
  }
}

if (window.location.pathname === '/pages/search-results-page') {
  document.getElementById('MainContent')?.classList.add('bg-gray-300');
  updateSearchResults();

  let previousUrl = '';
  const observer = new MutationObserver(function(callback) {
    if (location.href !== previousUrl) {
      previousUrl = location.href;

      updateSearchResults();
    }

    for (let i = 0; i < callback.length; i += 1) {
      callback[i].removedNodes.forEach(function (node) {
        if (node.classList?.contains('snize-main-panel-dropdown-content')) {
          updateSearchResults();
          updateSortList();
        }
      });
    }
  });

  observer.observe(document, { subtree: true, childList: true });

  window.addEventListener('resize', updateSearchResults);
}